import {Injectable} from '@angular/core';
import { ApiEndpoints } from './ApiEndpoints';
import { HttpClient } from '@angular/common/http';
import { ApiUtils } from './ApiUtils';
import { SharedMethods } from '../../../util/sharedMethods-service';


@Injectable()
export class SettingService {

  from = '';
  to = '';
  fromEtat = '';
  toEtat= '';

  toCreancePartenaire: string;
  fromCreancePartenaire: string;

  toCaisse= '';
  fromCaisse= '';

  toInventory: string;
  fromInventory: string;



  // sessionState = '';

  search = false;
  messageSearch = 'Recherche en cours...';



  toEtatCommande: string;
  fromEtatCommande: string;

  periode = '';


  constructor( ) {

     this.init();

  }

  init() {

    // this.from =   new Date().toISOString().split('T')[0];

    // this.toEtat = ( new Date()).toISOString().split('T')[0];

    this.toCaisse = ( new Date()).toISOString().split('T')[0];

    // on ajoute un intervale entre form et to

    /* const dt = new Date();
    dt.setMonth( new Date().getMonth() + 1 );
    this.to =  dt.toISOString().split('T')[0]; */
    this.from = this.getCurrentDay();
    this.to = this.getCurrentDay();

  }

  getCurrentDay(): string {
    this.periode = 'today';
    return ( new Date()).toISOString().split('T')[0];
  }

  getCurrentWeek(): any {
    const curr = new Date;
    const first =  curr.getDate() - curr.getDay() + 1;
    const last = first + 6;
    this.periode = 'week';

    return {
      from: ( new Date(curr.setDate(first))  ).toISOString().split('T')[0],
      to: ( new Date(curr.setDate(last))).toISOString().split('T')[0],
    };
  }

  getCurrentMonth(): any {
    const today = new Date();
    // Définir le paramètre de jour sur 1 signifie un jour de moins que le premier jour du mois qui est le dernier jour du mois précédent.
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    const firthDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2);

    this.periode = 'month';
    // alert(firthDayOfMonth.toISOString().split('T')[0] + ' - ' + lastDayOfMonth.toISOString().split('T')[0]);
    return {
      from: firthDayOfMonth.toISOString().split('T')[0],
      to: lastDayOfMonth.toISOString().split('T')[0],
    };

  }


  getCurrentYear(): any {
    const today = new Date();
    // Définir le paramètre de jour sur 1 signifie un jour de moins que le premier jour du mois qui est le dernier jour du mois précédent.
    const lastDayOfYear = new Date(today.getFullYear(), 12, 1);
    const firthDayOfYear = new Date(today.getFullYear(), 0, 2);
    this.periode = 'year';
    return {
      from: firthDayOfYear.toISOString().split('T')[0],
      to: lastDayOfYear.toISOString().split('T')[0],
    };
    // alert(firthDayOfMonth.toISOString().split('T')[0] + ' - ' + lastDayOfMonth.toISOString().split('T')[0]);
  }

  formatDate(date: string) {
      if (date !== null && date !== undefined) {
        const tab = date.split('-');
        return  tab[2] + '/' + tab[1] + '/' + tab[0];
        // return new Date(date).toISOString;
      } else {
        return '';
      }
  }


  back() {
    window.history.back();
  }




}
